/**
 * Normalize a phone number string to (XXX) XXX-XXXX format.
 * Handles: dots (360.631.7166), country code (+13606317166),
 * dashes, spaces, parens, and raw digits.
 * Returns the original string if it doesn't look like a valid US phone number.
 */
export function normalizePhone(phone: string): string {
  if (!phone) return phone;

  // Strip everything except digits
  let digits = phone.replace(/\D/g, '');

  // Remove leading country code 1 if 11 digits
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }

  // Format as (XXX) XXX-XXXX if we have exactly 10 digits
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // Return original trimmed if we can't normalize
  return phone.trim();
}
